import { useEffect, useState } from "react";
import axios from "axios";
import { IoSearch } from "react-icons/io5";
import { PaymentTransactionModal } from "../components/AdminUserManagmentComponent/PaymentTransactionModal";
import { FaCircleChevronRight } from "react-icons/fa6";
import { FaChevronCircleLeft } from "react-icons/fa";

const PaymentTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [recent, setRecent] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedTx, setSelectedTx] = useState(null);
  const [status, setStatus] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    fetchTransactions();
  }, [page, search,status]);

  useEffect(() => {
  const timer = setTimeout(() => {
    setPage(1);
    setSearch(searchInput);
  }, 500);

  return () => clearTimeout(timer);
}, [searchInput]);


  const fetchTransactions = async () => {
    const res = await axios.get(
      "/api/v1/app/payments/admin/payment-transactions",
      {
        params: { page, limit: 10, search , status },
      }
    );

    if (res.data.status === "OK") {
      setTransactions(res.data.data.transactions);
      setRecent(res.data.data.transactions.slice(0, 5));
      setTotalPages(res.data.data.pagination.totalPages);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl border-2 border-gray-200">

      {/* SEARCH */}


      <div className="flex justify-end gap-3 mb-4">

  {/* SEARCH */}
  <div className="relative w-72">
    <IoSearch className="absolute top-3 left-3" />
    <input
      placeholder="Search payments..."
      value={searchInput}
      onChange={(e) => setSearchInput(e.target.value)}
      className="pl-10 pr-4 py-2 border rounded-xl w-full"
    />
  </div>

  {/* STATUS FILTER 🔥 */}
  <select
    value={status}
    onChange={(e) => {
      setPage(1); // reset page
      setStatus(e.target.value);
    }}
    className="px-4 py-2 border-2 border-gray-200 rounded-xl text-sm"
  >
    <option value="">All Status</option>
    <option value="COMPLETED">Completed</option>
    <option value="PENDING">Pending</option>
    <option value="FAILED">Failed</option>
    <option value="CANCELLED">Cancelled</option>
  </select>

</div>

      {/* RECENT */}
      <h3 className="font-bold mb-3 text-[var(--primary-solid)]">
        Recent Transactions
      </h3>



      <div className="grid grid-cols-2 gap-4 mb-6">
  {

    recent.length === 0 ? (
    <div className="col-span-2 border-2 border-dashed border-gray-200 rounded-xl py-10">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="text-4xl mb-2">💳</div>

        <h3 className="font-semibold text-gray-700">
          No Recent Transactions Found
        </h3>

        {search && (
          <p className="text-sm text-gray-500 mt-1">
            No recent transactions match "
            <span className="font-medium">{search}</span>"
          </p>
        )}

        {!search && status && (
          <p className="text-sm text-gray-500 mt-1">
            No recent transactions available for selected status.
          </p>
        )}
      </div>
    </div>
  ) : (
  
  recent.map((tx) => {
    const status = tx?.status || "—";
    const stNorm = String(status).toLowerCase();

    const stClass =
      stNorm === "completed"
        ? "bg-green-100 text-green-700 border-green-200"
        : stNorm === "pending"
        ? "bg-yellow-100 text-yellow-700 border-yellow-200"
        : stNorm === "failed" || stNorm === "cancelled"
        ? "bg-red-100 text-red-700 border-red-200"
        : "bg-gray-100 text-gray-600 border-gray-200";

    return (
      <div
        key={tx._id}
        onClick={() => setSelectedTx(tx)}
        className="border-2 border-gray-200 p-4 rounded-xl cursor-pointer hover:border-[var(--primary-solid)] transition"
      >
        {/* USER */}
        <div className="flex items-center gap-3 mb-2">
          <img
            src={tx.user?.profileImage || "/default-avatar.png"}
            className="w-10 h-10 rounded-full"
          />
          <div>
            <p className="font-semibold">{tx.user?.fullName}</p>
            <p className="text-xs text-gray-500">{tx.packageName}</p>
          </div>
        </div>

        {/* AMOUNT */}
        <p className="text-sm font-medium">₹{tx.amount}</p>

        {/* STATUS BADGE 🔥 */}
        <div className="mt-2">
          <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-semibold ${stClass}`}
          >
            {String(status).toUpperCase()}
          </span>
        </div>
      </div>
    );
  }))}
</div>

      {/* TABLE */}
      <h3 className="font-bold mb-3 text-[var(--primary-solid)]">
        All Transactions
      </h3>




<div className="overflow-x-auto border-2 border-gray-200 rounded-xl">
  <table className="w-full text-sm">
    <thead>
      <tr className="bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white text-xs uppercase font-semibold">
        <th className="py-3 px-4 text-left">Date</th>
        <th className="py-3 px-4 text-left">User</th>
        <th className="py-3 px-4 text-left">Package</th>
        <th className="py-3 px-4 text-left">Coins</th>
        <th className="py-3 px-4 text-left">Amount</th>
        <th className="py-3 px-4 text-left">Status</th>
      </tr>
    </thead>

    <tbody>
      {
      
      transactions.length === 0 ? (
    <tr>
      <td
        colSpan="6"
        className="py-12 text-center text-gray-500 font-medium"
      >
        <div className="flex flex-col items-center gap-2">
          <span className="text-lg">
            No Transactions Found
          </span>

          {search && (
            <span className="text-sm text-gray-400">
              No results found for "{search}"
            </span>
          )}
        </div>
      </td>
    </tr>
  ) : (
      
      
      transactions.map((tx, idx) => {
        const date = tx?.createdAt
          ? new Date(tx.createdAt).toLocaleString()
          : "—";

        const status = tx?.status || "—";
        const stNorm = String(status).toLowerCase();

        const stClass =
          stNorm === "completed"
            ? "bg-green-100 text-green-700 border-green-200"
            : stNorm === "pending"
            ? "bg-yellow-100 text-yellow-700 border-yellow-200"
            : stNorm === "failed" || stNorm === "cancelled"
            ? "bg-red-100 text-red-700 border-red-200"
            : "bg-gray-100 text-gray-600 border-gray-200";

        return (
          <tr
            key={tx._id || idx}
            onClick={() => setSelectedTx(tx)}
            className="border-t border-gray-200 cursor-pointer hover:bg-purple-500 transition"
          >
            <td className="py-3 px-4">{date}</td>

            <td className="py-3 px-4">
              <div className="flex items-center gap-2">
                <img
                  src={tx.user?.profileImage}
                  className="w-8 h-8 rounded-full"
                />
                {tx.user?.fullName || "—"}
              </div>
            </td>

            <td className="py-3 px-4">{tx.packageName}</td>

            <td className="py-3 px-4">{tx.coins}</td>

            <td className="py-3 px-4 font-semibold">
              ₹{tx.amount}
            </td>

            <td className="py-3 px-4">
              <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-semibold ${stClass}`}
              >
                {String(status).toUpperCase()}
              </span>
            </td>
          </tr>
        );
      }))}
    </tbody>
  </table>
</div>


<div className="flex items-center justify-center mt-6">
  <div className="flex items-center gap-2 bg-white border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm">

    {/* PREVIOUS */}
    <button
      disabled={page === 1}
      onClick={() => setPage((p) => Math.max(1, p - 1))}
      className="px-3 py-2 rounded-lg text-sm font-semibold transition 
        bg-[var(--yellow)] text-[var(--black)]
        disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-80"
    >
      <FaChevronCircleLeft />
    </button>

    {/* PAGE INFO */}
    <span className="text-sm font-semibold text-[var(--black-text)]">
      Page {page} / {totalPages}
    </span>

    {/* NEXT */}
    <button
      disabled={page === totalPages}
      onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
      className="px-3 py-2 rounded-lg text-sm font-semibold transition 
        bg-[var(--yellow)] text-[var(--black)]
        disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-80"
    >
      <FaCircleChevronRight />
    </button>

  </div>
</div>


      {/* MODAL */}
      {selectedTx && (
        <PaymentTransactionModal
          transaction={selectedTx}
          onClose={() => setSelectedTx(null)}
        />
      )}
    </div>
  );
};

export default PaymentTransactions;